<template>
  <div class="card br-16 p-x3 w-80p" style="box-shadow: 0 2px 8px rgba(0,0,0, 0.10)">
    <div>
      <div class="t-xl m-b4 ta-c bold">Select where channel messages will be sent</div>
      <div class="t m-bx3 ta-c gray">Some messages will be sent to the channels you select below.<br>You can edit channels and messages later.</div>
    </div>
    <div class="f-h flexed f-gap-8">
      <div class="f-v fc-g1 fc-b0p">
        <div class="t bold m-bx1">Select channels</div>
        <div class="b-2 br-8">
          <!--  TODO: Refactor this style for donut details into its own component (along with wizard index)  -->
          <donut-details
            v-for="(event, idx) in events"
            :key="event.id"
            v-model="selectedEventId"
            :class="{'b-t2': idx > 0, 'p-x1': true}"
            :value="event.id"
          >
            <summary class="c-p">
              <div class="f-h f-gap-8 f-ac">
                <i v-if="event.channel" class="mi purple">check_circle</i>
                <i v-else class="mi border">radio_button_unchecked</i>
                <div class="t-lg fc-g3">{{ event.title }}</div>
              </div>
            </summary>
            <div class="f-v m-tx1">
              <donut-selector-prefabs-channel
                v-model="event.channel"
                :include-private="true"
              />
            </div>
          </donut-details>
        </div>
      </div>
      <div class="f-v fc-g1 fc-b0p">
        <div class="t bold m-bx1">Message preview</div>
        <onboarding-events--preview :event="eventForPreview" :include-day="true" />
      </div>
    </div>
    <donut-button
      class="fc-ae m-tx3"
      :disabled="saveDisabled"
      :is-loading="isSaving"
      @click="clickSave"
    >
      Save
    </donut-button>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import Network from '../../../../lib/api/network';

  const { dispatch, state } = useStore();

  const events = computed(() => state.journeyBuilderWorkflow.events_requiring_user_input.channel_messaging || []);

  const selectedEventId = ref(events.value[0]?.id);
  const selectedEvent = computed(() => events.value.find(e => e.id === selectedEventId.value));
  const eventForPreview = computed(() => {
    const ev = selectedEvent.value;
    if (!ev) return {};

    return {
      message: ev.message,
      days_later: ev.days_later,
      minute_in_day: ev.minute_in_day,
      channel: ev.channel || { name: '{#Channel}' },
    };
  });

  const saveDisabled = computed(() => events.value.some(e => !e.channel?.id));
  const isSaving = ref(false);

  const clickSave = () => {
    if (saveDisabled.value) return;

    isSaving.value = true;

    Network.put(
      `/journey_builder/${state.journeyBuilderWorkflow.id}/update_draft_events`,
      {
        events: events.value.map(e => ({
          id: e.id,
          channel_id: e.channel.id,
          requires_user_input_type: null, // Getting a channel id resolves them, they no longer need user input.
        })),
      },
      {
        success: () => {
          // Wipe out this field because they were all resolved. This moves the page along too.
          state.journeyBuilderWorkflow.events_requiring_user_input.channel_messaging = [];
        },
        error: () => {
          dispatch('setErrorToast');
        },
        complete: () => {
          isSaving.value = false;
        },
      },
    );
  };
</script>
